module.exports = __webpack_public_path__ + "static/media/gacha-banner-1.62d45105.png";